import React from 'react';
import { color, space } from '../../theme';
import { Badge } from '../Badge';
import Icon from '../Icon';

// A broadcast's status: on air, on a break, or neither
export type LiveState = 'live' | 'paused' | null;

/* "בשידור" (red, with the live dot) or "בהפסקה" (grey, with a pause icon) on committee cards
   and session cards (decision 1D). Status only, never clickable. */
const LiveBadge = ({ state }: { state: LiveState }) => {
  if (state === 'live') return <Badge tone="danger" dot={color.live}>בשידור</Badge>;
  if (state === 'paused') {
    return <Badge><span style={{ display: 'inline-flex', alignItems: 'center', gap: space.xs }}><Icon name="pause" size={12} />בהפסקה</span></Badge>;
  }
  return null;
};

export default LiveBadge;
